var modules_67e042e7 = {"cell":"_82cq1h","icons":"_18x43kp","pointer":"_1wnld5n"};
import "../../../assets/qMnTUBXi.css";

export { modules_67e042e7 as default };
//# sourceMappingURL=Head.module.less.js.map
